<div [formGroup]="form">
  <div class="mt-3 text-muted small" i18n="@@collection.config.tab.rules.blockly.info">
    Develop any automation from custom blocks. Triggers automatically upon record update or manually via an action button.
  </div>
  <div class="my-3 d-flex flex-wrap align-items-center justify-content-start">
    <div class="text-nowrap fw-bold" i18n="@@collection.config.tab.rules.blockly.editAutomation.message">Edit Automation Code:</div>
    <div class="flex-grow-1 text-end">
      <div class="form-check me-3 d-inline-block">
        <input class="form-check-input" type="checkbox" formControlName="blocklyRecursive" id="blocklyRecursive">
        <label class="form-check-label" for="blocklyRecursive">
          <span i18n="@@collection.config.tab.rules.blockly.recursive">Recursive</span>
          <i class="far fa-question-circle ms-1" tooltip="Trigger also on changes made by other automations" i18n-tooltip="@@collection.config.tab.rules.blockly.recursive.tooltip"></i>
        </label>
      </div>
      <div class="form-check me-3 d-inline-block">
        <input class="form-check-input" type="checkbox" formControlName="blocklyDryRun" id="blocklyDryRun">
        <label class="form-check-label" for="blocklyDryRun" i18n="@@collection.config.tab.rules.blockly.dryRun">
          Dry Run
        </label>
      </div>
      <blockly-debugger-remote
        (displayEvent)="display($event)"
        [displayButtons]="debugButtons">
      </blockly-debugger-remote>
    </div>
  </div>
  <blockly-debugger
    (displayEvent)="display($event)"
    [displayDebug]="displayDebug"
    [blocklyJs]="blocklyJs"
    [blocklyError]="blocklyError"
    [blocklyDryRunResult]="blocklyDryRunResult"
    [blocklyResultTimestamp]="blocklyResultTimestamp">
  </blockly-debugger>

  <blockly-editor
    (onJsUpdate)="onJsUpdate($event)"
    (onXmlUpdate)="onXmlUpdate($event)"
    [serviceLimits]="serviceLimits$ | async"
    [toolbox]="functionToolbox"
    [collections]="collections$ | async"
    [views]="views$ | async"
    [linkTypes]="linkTypes$ | async"
    [variables]="variables"
    [variableNames]="variableNames$ | async"
    [selectionLists]="selectionLists$ | async"
    [xml]="blocklyXml">
  </blockly-editor>

</div>
